

















































































































import { Component, Vue, Emit, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import { Equipamento } from '@/types/_'
import EventBus from '@/plugins/EventBus'

@Component

export default class ComponentModalSolicitacaoCirurgiaEquipamento extends Vue {
  equipamentoLock: boolean = false
  inputSearch: string = ''
  loading: any = {
    searchProcedimento: false,
    listText: 'Equipamento não encontrado.',
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getRequestMessage() {
    return this.getSolicitacaoStore.requestMessage
  }

  get getInputSearch() {
    return this.inputSearch
  }

  set getInputSearch(value) {
    this.inputSearch = value
  }

  get showModalEquipamento() {
    return this.getSolicitacaoStore.modalSolicitacaoCirurgia.showEquipamento
  }

  get getEquipamentos() {
    return this.getSolicitacaoStore.equipamentos
  }

  get getEquipamentosApi() {
    return this.getSolicitacaoStore.equipamentosApi
  }

  @Watch('showModalEquipamento')
  onChangeGetShowModalEquipamento(value) {
    setTimeout(() => {
      const input = document.querySelector('.equipamento-input input') as HTMLInputElement
      if (value) {
        input.focus()
      } else {
        input.blur()
      }
    }, 100)
  }

  toggleBodyOverflow(isOpen: Boolean) {
    const html = document.querySelector('body')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
      }
    }
  }

  async addSelected(equipamento: Equipamento) {
    if (!this.equipamentoLock) {
      this.equipamentoLock = true
      EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.post })
      await this.getSolicitacaoStore.postEquipamento(equipamento)
      this.getSolicitacaoStore.removeEquipamentoApi(equipamento)
      this.loading.listText = 'Todos os itens foram selecionados.'
      EventBus.$emit('clearLoadingRequest')
      this.equipamentoLock = false
    }
  }

  async removeChip(equipamento: Equipamento) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.deleteMessage })
    const request = await this.getSolicitacaoStore.deleteEquipamento(equipamento)

    if (request.success) {
      this.getSolicitacaoStore.removeEquipamento(equipamento)
      this.getSolicitacaoStore.setEquipamentoApi(equipamento)
    }
    EventBus.$emit('clearLoadingRequest')
  }

  closeModalEquipamento() {
    this.clear()
    this.getSolicitacaoStore.setShowModalEquipamento(false)
  }

  debounce = _.debounce(input => this.getSolicitacaoStore.getAllGrupoEquipamentoParaOMedico(input), 600)

  search() {
    if (this.inputSearch.length === 0 || this.inputSearch.length > 2) {
      this.debounce(this.inputSearch)
    }
  }

  clear() {
    this.getInputSearch = ''
  }
}

